import { OPERATOR_FLOW } from '../operator/operatorConstants';
import { isRetryable } from '../operator/operatorErrors';
import { offScreenFailure, offScreenSignal } from '../operator/operatorTaskScope';
import { dispatchLoad, loadDispatchOrder, retryFailedDispatch, scanDispatchCode } from './operatorDispatchThunks';
import { loadOrderMessage, recheckSignal, resultSignal, scanMessage } from './operatorDispatchUtils';

/**
 * What the band says for each dispatch outcome; see `operatorListeners`.
 *
 * A read says what it did to the load: «ORD-1 · bulto 2 de 3», «ORD-1
 * completa», «Ese bulto ya está en la carga»; an order that cannot go up says
 * why, in red: it must not go on the truck. Once the station is off screen a
 * read says nothing. The dispatch says how many left, named «Despacho» off
 * screen; a lost answer offers «Reintentar» wherever it shows: the band
 * carries the dispatch, and its key keeps it from leaving twice.
 */
export const DISPATCH_SIGNAL_RULES = {
  [scanDispatchCode.typePrefix]: {
    success: ({ payload, meta }) => (meta.offScreenTask ? null : scanMessage(payload.outcome)),
    error: ({ meta }) => (meta.offScreenTask ? null : undefined),
  },
  [loadDispatchOrder.typePrefix]: {
    success: ({ payload, meta }) => (meta.offScreenTask ? null : loadOrderMessage(payload.outcome)),
    error: ({ meta }) => (meta.offScreenTask ? null : undefined),
  },
  [retryFailedDispatch.typePrefix]: {
    success: ({ payload }) => (payload.checks.length > 0 ? recheckSignal(payload.checks) : null),
  },
  [dispatchLoad.typePrefix]: {
    success: ({ payload, meta }) => {
      const signal = resultSignal(payload);
      return meta.offScreenTask ? offScreenSignal(meta.offScreenTask, signal) : signal;
    },
    error: ({ payload, meta }, fallback) => {
      const name = meta.offScreenTask;
      if (!name) return undefined;
      return isRetryable(payload) ? offScreenSignal(name, fallback) : offScreenFailure(name, payload, 'no salió');
    },
    retry: OPERATOR_FLOW.DISPATCH,
    keyed: true,
  },
};
